import API from './api';

export const authService = {
  login:    (credentials) => API.post('/api/auth/login/', credentials),
  register: (userData)    => API.post('/api/auth/register/', userData),
  logout:   ()            => API.post('/api/auth/logout/'),
  me:       ()            => API.get('/api/auth/me/'),
  changePassword: (data)  => API.post('/api/auth/change-password/', data),

  // Two-Factor Authentication — login TOTP verify
  verify2fa: (data) => API.post('/api/auth/2fa/verify/', data),

  // 2FA setup flow (setup_token-based, no auth token needed)
  verifyEmailOtp: (setup_token, code) =>
    API.post('/api/auth/2fa/email-verify/', { setup_token, code }),
  resendEmailOtp: (setup_token) =>
    API.post('/api/auth/2fa/resend-otp/', { setup_token }),
  get2faSetup: (setup_token) =>
    API.get('/api/auth/2fa/setup/', { params: setup_token ? { setup_token } : {} }),
  enable2fa: (setup_token, code) =>
    API.post('/api/auth/2fa/setup/', { setup_token, code }),

  // Disable 2FA (authenticated user)
  disable2fa: (code) => API.delete('/api/auth/2fa/setup/', { data: { code } }),
};
